<!--upload:上传答题卡 2024/07/18 14:26:31 YuAng-->

<template>
  <div class="third-upload cnt1200">
    <page-header title :paths="['上传答题卡图片']">
      <p @click="downloadExe" class="download">
        下载客户端
        <img src="@/v3/modules/card_use/assets/images/download-icon.png" width="16px" />
      </p>
    </page-header>
    <div class="upload-body">
      <div class="upload-basic">
        <span class="span-label">年级：</span>
        <el-select v-model="upload.grade" @change="loadSubjects()" size="mini" placeholder="选择年级" :disabled="selectDisabled">
          <el-option v-for="(grade, index) in gradeList" :key="'grade' + index" :label="grade.gradeName" :value="grade.gradeNum"></el-option>
        </el-select>
        <span class="span-label" style="margin-left: 40px">学科：</span>
        <el-select v-model="upload.subjectCode" size="mini" placeholder="选择科目" :disabled="selectDisabled">
          <el-option v-for="(subject, index) in subjectList" :key="'subject' + index" :label="subject.subjectName" :value="subject.subjectId"></el-option>
        </el-select>
        <span class="span-label" style="margin-left: 40px">阅卷方式：</span>
        <el-select v-model="upload.isHen" size="mini" placeholder="选择阅卷方式" :disabled="selectDisabled">
          <el-option v-for="(hen, index) in hens" :key="'hen' + index" :label="hen.name" :value="hen.value"></el-option>
        </el-select>
      </div>
      <div class="upload-pic">
        <span class="span-label">上传图片：</span>
        <client-scan type="scan-card-template" :exam="examDemo" @change="uploadedAction" :paper-num="1"></client-scan>
      </div>
      <div class="upload-images">
        <div v-if="upload.ossUrl" class="upload-image">
          <el-image :src="upload.ossUrl" :preview-src-list="[upload.ossUrl]" fit="scale-down" style="width:100%;height:100%"></el-image>
          <span class="el-icon-circle-close" @click="upload.ossUrl = ''"></span>
        </div>
        <el-button v-else class="upload-image" disabled>
          <p class="add">
            <img alt="添加图片" src="../../assets/images/add_img.png" />
          </p>
        </el-button>
      </div>
      <div class="upload-footer">
        <p>支持 jpg、png格式，小于5M</p>
        <el-button type="primary" class="ok-btn" size="mini" @click="createCard((data) => { showCut(data) })">制作模板</el-button>
        <el-button v-if="!upload.examId" class="ok-btn" size="mini" @click="createCard()">确定</el-button>
      </div>
    </div>
  </div>
</template>
<script>
import PageHeader from '@/v2/views/components/PageHeader'
import { baseApi } from '@/v2/utils/api'
import { cardApi } from '@/v3/modules/card/utils/api'
import AliOSS from 'ali-oss'
import { mapGetters } from 'vuex'
import { cardData } from '@/v2/utils/data'
import ClientScan from '@/v3/modules/card_use/views/student-answer/components/ClientScan.vue'
import util from '@/v2/utils/util'

export default {
  components: { PageHeader, ClientScan },
  name: 'upload',
  data () {
    return {
      examDemo: {
        examCode: 'examCode',
        examName: 'examName'
      },
      subjectList: [],
      upload: {
        subjectCode: '',
        grade: '',
        ossUrl: '',
        isHen: 'NON_WRITING'
      },
      hens: cardData.getHens()
    }
  },
  computed: {
    ...mapGetters({
      userInfo: "getUserInfo",
      gradeList: 'getGradeList'
    }),
    selectDisabled () {
      // 考试列表跳转快速创建第三方制卡，年级、学科不允许编辑
      return !!this.upload.examId
    }
  },
  created () {
    const { grade, markingWay, examId } = this.$route.query
    this.upload.grade = grade ? parseInt(grade) : ''
    this.upload.isHen = markingWay === 'traceable' ? 'WRITING' : 'NON_WRITING'
    this.upload.examId = examId
    this.examDemo.examName = '第三方卡模板'
    this.examDemo.examCode = 'userId_' + this.userInfo.userId + '_' + this.generateRandomId()
    baseApi.getSTSToken().then(opt => {
      this.ossClient = new AliOSS(opt)
    })
    if (grade) {
      this.loadSubjects()
    }
  },
  methods: {
    downloadExe () {
      this.$root.$children[0].downloadExe()
    },
    loadSubjects () {
      this.upload.subjectCode = ''
      if (!this.upload.grade) {
        this.subjectList = []
        return
      }
      baseApi.getGradeSubjects({
        grade: this.upload.grade,
        schoolId: this.userInfo.schoolId,
      }).then(resp => {
        if (resp.body) {
          const data = resp.body
          const subject = data.find(item => item.subjectId === this.$route.query.subjectCode)
          if (subject) {
            this.upload.subjectCode = subject.subjectId
          }
          this.subjectList = data
        } else {
          this.subjectList = []
        }
      })
    },
    async createCard (callback) {
      const { grade, subjectCode, ossUrl, isHen } = this.upload
      if (!grade) {
        return this.$message.warning('未设置年级')
      } else if (!subjectCode) {
        return this.$message.warning('未设置学科')
      } else if (!ossUrl) {
        return this.$message.warning('还没上传图片')
      }

      const gradeInfo = this.gradeList.find(item => item.gradeNum === grade)
      const subjectInfo = this.subjectList.find(item => item.subjectId === subjectCode)
      const params = { ossUrl, schoolId: this.userInfo.schoolId, grade, subjectCode, isHen }
      const resp = await cardApi.uploadCardImg(params)
      if (resp.body) {
        resp.body.gradeName = gradeInfo.gradeName
        resp.body.subjectName = subjectInfo.subjectName
        resp.body.examId = this.upload.examId
        if (callback) {
          callback(resp.body)
        } else {
          this.$router.back()
        }
      } else {
        this.$message.error(resp.message || '上传失败')
      }
    },
    showCut (data) {
      const { grade, subjectCode, isHen, ossUrl, examId, gradeName, subjectName } = data
      const date = new Date()
      const year = date.getFullYear()
      const name = gradeName + subjectName + year.toString().slice(-2) + util.generateDateTimeString()
      const router = {
        path: '/v2/card/third/cut',
        query: {
          name,
          type: isHen,
          grade: grade,
          subjectCode: subjectCode,
          ossUrl: ossUrl,
          indexExamId: examId
        }
      }
      if (data.source) {
        this.$router.replace(router)
      } else {
        this.$router.push(router)
      }
    },
    uploadedAction (resp) {
      if (resp.code === 200) {
        const body = resp.body
        if (body && body.command) {
          if (body.command === 'local-upload-progress' || body.command === 'report-upload-progress') {
            this.upload.ossUrl = body.ossUrl
          }
        } else {
          this.upload.ossUrl = ''
        }
      } else {
        this.$message.warning(resp.message)
      }
    },
    generateRandomId () {
      return Math.floor((1 + Math.random()) * 0x10000).toString(16).substring(1);
    },
  }
}
</script>

<style scoped>
.third-upload {
  margin-bottom: 16px;
}

.third-upload ::v-deep .page-header {
  border-bottom: none;
}

.download {
  display: flex;
  align-items: center;
  color: #2877ff;
  text-align: center;
  font-family: "PingFang SC";
  font-style: normal;
  font-weight: 400;
  line-height: 14px;
  justify-content: right;
  font-size: 14px;
  cursor: pointer;
}

.download > img {
  margin-left: 5px;
  width: 16px;
}

.upload-body {
  padding: 24px 32px;
  background: white;
  margin-top: 16px;
  min-height: calc(100vh - 274px);
}

.upload-basic {
  display: flex;
  align-items: center;
}

.upload-basic ::v-deep input {
  font-size: 14px;
  padding-left: 8px;
}

.upload-basic ::v-deep input::placeholder {
  color: #999;
}

.span-label {
  display: inline-block;
  width: 75px;
  font-size: 14px;
}

.upload-pic {
  display: flex;
  align-items: center;
  margin-top: 12px;
}

.upload-images {
  display: flex;
  flex-wrap: wrap;
  margin-bottom: 10px;
}

.upload-image {
  width: 566px;
  height: 357px;
  background: #f0f0f0;
  margin-left: 76px;
  margin-top: 10px;
  position: relative;
  border-radius: 4px;
}

.upload-image .add {
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 4px;
  width: 566px;
  height: 357px;
}

.el-icon-circle-close {
  position: absolute;
  top: -9px;
  right: -9px;
  font-size: 18px;
  display: none;
}

.upload-image:hover .el-icon-circle-close {
  display: block;
}

.upload-footer {
  font-size: 12px;
  color: #666666;
  padding-left: 74px;
  width: 566px;
  height: 100px;
}

.upload-footer ::v-deep .el-button {
  padding: 8px 36px;
  float: right;
  margin-top: 30px;
  margin-left: 20px;
}
</style>